import React, { useCallback, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import axios from "axios";
import { FaCheck, FaEdit, FaTimes } from "react-icons/fa";
import myToast from "../Utils/MyToast";
import SessionManager from "../Utils/SessionManager";
import "../css/Admin_css/admin-customize.css";

const API_BASE = () =>
  `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}`;

const PAPER_TYPES = [
  { value: "Written", code: "1" },
  { value: "Oral", code: "2" },
  { value: "Theory", code: "3" },
  { value: "Practical", code: "4" },
  { value: "Project", code: "5" },
  { value: "Test", code: "6" },
  { value: "PT", code: "7" },
  { value: "NB", code: "8" },
  { value: "SE", code: "9" },
  { value: "SA", code: "10" },
  { value: "(W)", code: "11" },
  { value: "(O)", code: "12" },
  { value: "(P)", code: "13" },
  { value: "(T)", code: "14" },
  { value: "(NB)", code: "15" },
  { value: "(SE)", code: "16" },
  { value: "(SA)", code: "17" },
  { value: "(PT)", code: "18" },
  { value: "(TEST)", code: "19" },
  { value: "(TH)", code: "20" },
];

const DIALOG_STYLES = `
  .modal.show { display: block !important; opacity: 1 !important; }
  .modal.fade.show { opacity: 1 !important; }
  .mdl-edit-paper-dialog.modal-dialog {
    z-index: 1050 !important;
    position: relative;
    margin: 0.45rem auto 1rem;
    max-width: 720px;
  }
  .mdl-edit-paper-dialog.modal-dialog.modal-dialog-centered {
    min-height: calc(100% - 1rem);
  }
  .modal-backdrop { z-index: 1040 !important; }
  .modal-backdrop.show { opacity: 0.5 !important; }
  .mdl-edit-paper-dialog .modal-content {
    z-index: 1051 !important;
    position: relative;
    border-radius: 16px;
    overflow: hidden;
    border: 2px solid rgba(179, 229, 252, 0.55);
    box-shadow: 0 12px 28px rgba(2, 136, 209, 0.14);
    background: #fff;
  }
  .mdl-edit-paper-dialog .modal-header {
    border: none;
    padding: 12px 16px;
    background: linear-gradient(135deg, #03a9f4 0%, #0288d1 55%, #01579b 100%);
  }
  .mdl-edit-paper-dialog .modal-header .close {
    color: #fff;
    opacity: 0.92;
    text-shadow: none;
    font-size: 1.35rem;
    font-weight: 400;
    padding: 0.35rem 0.55rem;
  }
  .mdl-edit-paper-dialog .modal-body {
    padding: 12px 14px 10px;
    background: linear-gradient(180deg, #f7fcff 0%, #ffffff 42%);
  }
  .mdl-edit-paper-dialog .modal-footer {
    border-top: 1px solid #e1f5fe;
    padding: 10px 14px;
    background: #f0f9ff;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }
  .mep-title {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin: 0;
    color: #fff;
    width: 100%;
    padding-right: 18px;
  }
  .mep-title__icon {
    width: 34px;
    height: 34px;
    border-radius: 10px;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(255,255,255,0.18);
    border: 1px solid rgba(255,255,255,0.35);
    font-size: 15px;
  }
  .mep-title__main { font-size: 16px; font-weight: 800; line-height: 1.2; }
  .mep-title__sub {
    margin-top: 2px;
    font-size: 11px;
    font-weight: 500;
    color: rgba(255,255,255,0.88);
  }
  .mep-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-bottom: 10px;
  }
  .mep-pill {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    min-height: 26px;
    padding: 3px 10px;
    border-radius: 999px;
    border: 1px solid #b3e5fc;
    background: #e1f5fe;
    color: #01579b;
    font-size: 11px;
    font-weight: 700;
  }
  .mep-form {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    padding: 10px;
    border-radius: 10px;
    border: 2px solid rgba(179, 229, 252, 0.65);
    background: #fff;
  }
  .mep-field { display: flex; flex-direction: column; gap: 4px; }
  .mep-field--full { grid-column: 1 / -1; }
  .mep-field label {
    margin: 0;
    font-size: 10px;
    font-weight: 800;
    color: #0277bd;
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }
  .mep-field input,
  .mep-field select {
    min-height: 38px;
    border-radius: 8px;
    border: 2px solid rgba(179, 229, 252, 0.75);
    padding: 6px 10px;
    font-size: 13px;
    font-weight: 600;
    color: #37474f;
    background: #fff;
    outline: none;
  }
  .mep-field input:focus,
  .mep-field select:focus { border-color: #4fc3f7; }
  .mep-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    min-height: 36px;
    padding: 6px 14px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 800;
    border: 2px solid transparent;
    cursor: pointer;
  }
  .mep-btn:disabled { opacity: 0.55; cursor: not-allowed; }
  .mep-btn--ghost {
    background: #fff;
    border-color: #b3e5fc;
    color: #0277bd;
  }
  .mep-btn--ghost:hover:not(:disabled) { background: #e1f5fe; }
  .mep-btn--primary {
    background: linear-gradient(135deg, #03a9f4 0%, #0288d1 100%);
    border-color: #0288d1;
    color: #fff;
  }
  @media (max-width: 640px) {
    .mep-form { grid-template-columns: 1fr; }
  }
`;

const MdlEditPaper = ({ actionClose, paper, exam_id, exam_name, actionUpdate }) => {
  const [loading, setLoading] = useState(false);
  const [paperName, setPaperName] = useState("");
  const [paperNameNew, setPaperNameNew] = useState("");
  const [paperType, setPaperType] = useState("");
  const [paperTypeOld, setPaperTypeOld] = useState("");
  const [paperCode, setPaperCode] = useState("0");
  const [paperCodeOld, setPaperCodeOld] = useState("0");
  const [sessionId, setSessionId] = useState("");
  const [examPaperId, setExamPaperId] = useState("");
  const [isMarkSystem, setIsMarkSystem] = useState("");
  const [maxMarkOrGrade, setMaxMarkOrGrade] = useState("");
  const [maxMarkOrGradeNew, setMaxMarkOrGradeNew] = useState("");

  useEffect(() => {
    const styleTag = document.createElement("style");
    styleTag.setAttribute("data-mdl-edit-paper", "1");
    styleTag.textContent = DIALOG_STYLES;
    document.head.appendChild(styleTag);
    return () => {
      if (styleTag.parentNode) styleTag.parentNode.removeChild(styleTag);
    };
  }, []);

  useEffect(() => {
    if (!paper) return;
    setSessionId(paper.session_id || "");
    setExamPaperId(paper.exam_paper_id || "");
    setPaperName(paper.exam_paper_name || "");
    setPaperNameNew(paper.exam_paper_name || "");
    setPaperType(paper.paper_type || "");
    setPaperTypeOld(paper.paper_type || "");
    setPaperCode(String(paper.paper_code || "0"));
    setPaperCodeOld(String(paper.paper_code || "0"));
    setIsMarkSystem(paper.is_mark_system || "");
    if (paper.is_mark_system === "1") {
      setMaxMarkOrGrade(paper.max_mark || "");
      setMaxMarkOrGradeNew(paper.max_mark || "");
    } else {
      setMaxMarkOrGrade(paper.max_grade || "");
      setMaxMarkOrGradeNew(paper.max_grade || "");
    }
  }, [paper]);

  //Created By Cursor
  const handleClose = useCallback(() => {
    if (loading) return;
    actionClose();
  }, [actionClose, loading]);

  //Created By Cursor
  const handlePaperTypeChange = useCallback((e) => {
    const value = e.target.value;
    const option = e.target.options[e.target.selectedIndex];
    setPaperType(value);
    setPaperCode(option?.dataset?.paper_code || "0");
  }, []);

  //Created By Cursor
  const handleSubmit = useCallback(async () => {
    if (!paperNameNew?.trim()) {
      myToast.notify_warning("Please enter a paper name.");
      return;
    }
    if (!maxMarkOrGradeNew?.trim()) {
      myToast.notify_warning(
        `Please enter ${isMarkSystem === "1" ? "max mark" : "max grade"}.`
      );
      return;
    }
    if (!sessionId || !exam_id || !examPaperId) {
      myToast.notify_error("Missing required information. Please try again.");
      return;
    }

    setLoading(true);
    try {
      const schoolCode = SessionManager.getSchoolCode();
      const staffId = SessionManager.getStaffDetails()?.staff_id;
      if (!staffId) {
        myToast.notify_error("Staff information not found.");
        setLoading(false);
        return;
      }

      const response = await axios.get(`${API_BASE()}updateExamPaper.php`, {
        params: {
          school_code: schoolCode,
          staff_id: staffId,
          exam_id,
          session_id: sessionId,
          exam_name,
          exam_paper_id: examPaperId,
          is_mark_system: isMarkSystem,
          max_mark_or_grade: maxMarkOrGrade || "",
          max_mark_or_grade_new: maxMarkOrGradeNew,
          paper_name: paperName || "",
          paper_name_new: paperNameNew.trim(),
          paper_type: paperType || "",
          paper_code: paperCode || 0,
          paper_type_old: paperTypeOld || "",
          paper_code_old: paperCodeOld || 0,
        },
      });

      if (response.data?.api_status === "OK") {
        myToast.notify_success("Paper updated successfully!");
        handleClose();
        if (typeof actionUpdate === "function") actionUpdate();
      } else {
        myToast.notify_warning(
          response.data?.api_remark || "Failed to update paper. Please try again."
        );
      }
    } catch (error) {
      myToast.notify_error(
        error.response?.data?.api_remark ||
          "An error occurred while updating the paper."
      );
    } finally {
      setLoading(false);
    }
  }, [
    actionUpdate,
    examPaperId,
    exam_id,
    exam_name,
    handleClose,
    isMarkSystem,
    maxMarkOrGrade,
    maxMarkOrGradeNew,
    paperCode,
    paperCodeOld,
    paperName,
    paperNameNew,
    paperType,
    paperTypeOld,
    sessionId,
  ]);

  return (
    <Modal
      show
      onHide={handleClose}
      animation={false}
      centered
      dialogClassName="mdl-edit-paper-dialog"
      aria-labelledby="mdl-edit-paper-title"
    >
      <Modal.Header closeButton={!loading}>
        <div className="mep-title" id="mdl-edit-paper-title">
          <span className="mep-title__icon" aria-hidden>
            <FaEdit />
          </span>
          <div>
            <div className="mep-title__main">Edit Paper</div>
            <div className="mep-title__sub">
              Update name, type, and max value
            </div>
          </div>
        </div>
      </Modal.Header>

      <Modal.Body>
        <div className="mep-meta">
          <span className="mep-pill">
            System:{" "}
            <strong>{isMarkSystem === "1" ? "Marks" : "Grades"}</strong>
          </span>
          <span className="mep-pill">
            Current: <strong>{paperName || "—"}</strong>
          </span>
        </div>

        <div className="mep-form">
          <div className="mep-field">
            <label htmlFor="mep-paper-name">Paper Name</label>
            <input
              id="mep-paper-name"
              type="text"
              value={paperNameNew || ""}
              onChange={(e) => setPaperNameNew(e.target.value)}
              disabled={loading}
            />
          </div>

          <div className="mep-field">
            <label htmlFor="mep-paper-type">Paper Type</label>
            <select
              id="mep-paper-type"
              value={paperType || ""}
              onChange={handlePaperTypeChange}
              disabled={loading}
            >
              <option value="">Select Paper Type</option>
              {PAPER_TYPES.map((type) => (
                <option
                  key={type.code}
                  value={type.value}
                  data-paper_code={type.code}
                >
                  {type.value}
                </option>
              ))}
            </select>
          </div>

          <div className="mep-field mep-field--full">
            <label htmlFor="mep-max-value">
              {isMarkSystem === "1" ? "Max Mark" : "Max Grade"}
            </label>
            <input
              id="mep-max-value"
              type="text"
              value={maxMarkOrGradeNew || ""}
              onChange={(e) => setMaxMarkOrGradeNew(e.target.value)}
              disabled={loading}
            />
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button
          type="button"
          className="mep-btn mep-btn--ghost"
          onClick={handleClose}
          disabled={loading}
        >
          <FaTimes aria-hidden /> Cancel
        </button>
        <button
          type="button"
          className="mep-btn mep-btn--primary"
          onClick={handleSubmit}
          disabled={loading}
        >
          <FaCheck aria-hidden />
          {loading ? "Saving…" : "Save"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default MdlEditPaper;
